
import { Page, PresetTheme, Puzzle, GroupGame, Notification, defaultImageEdits, MockAd } from './types';

// Helper to create a fake Firestore Timestamp for mock data
// This avoids importing firebase.ts which causes circular dependency crashes at startup
const createMockTimestamp = () => {
    const now = new Date();
    return {
        toMillis: () => now.getTime(),
        toDate: () => now,
        seconds: Math.floor(now.getTime() / 1000),
        nanoseconds: 0,
        isEqual: (other: any) => false,
    } as any;
};

// --- PUZZLES (for Daily Challenge, which is static for now) ---
export const dailyChallengePuzzles: Puzzle[] = [
    {
        id: 'daily-1',
        creatorId: 'system',
        creatorProfile: { displayName: 'What Was It?', photoURL: 'https://i.imgur.com/gq4w0m8.png' },
        imageUrl: 'https://images.unsplash.com/photo-1542691457-03e2d6eb5046?q=80&w=2070&auto=format&fit=crop',
        clue: 'I have cities, but no houses. I have mountains, but no trees. I have water, but no fish. What am I?',
        answer: 'A MAP',
        category: 'Riddles',
        createdAt: createMockTimestamp(),
        likes: [], dislikes: [], hearts: [], comments: [],
        imageEdits: { ...defaultImageEdits, filter: 'filter-pixelate' },
        postColor: 'hsl(210, 50%, 25%)',
    },
    {
        id: 'daily-2',
        creatorId: 'system',
        creatorProfile: { displayName: 'What Was It?', photoURL: 'https://i.imgur.com/gq4w0m8.png' },
        imageUrl: 'https://images.unsplash.com/photo-1604200297054-f011b3beros?q=80&w=1887&auto=format&fit=crop',
        clue: 'This actor is known for his roles in "Pirates of the Caribbean" and "Edward Scissorhands".',
        answer: 'JOHNNY DEPP',
        category: 'Who is it?',
        createdAt: createMockTimestamp(),
        likes: [], dislikes: [], hearts: [], comments: [],
        imageEdits: { ...defaultImageEdits, filter: 'filter-heavy-blur' },
        postColor: 'hsl(25, 60%, 30%)',
    },
    {
        id: 'daily-3',
        creatorId: 'system',
        creatorProfile: { displayName: 'What Was It?', photoURL: 'https://i.imgur.com/gq4w0m8.png' },
        imageUrl: 'https://images.unsplash.com/photo-1571069357223-389a427b3a88?q=80&w=2070&auto=format&fit=crop',
        clue: 'This film features a green ogre, a talking donkey, and a princess who is also an ogre.',
        answer: 'SHREK',
        category: 'Which film is it?',
        createdAt: createMockTimestamp(),
        likes: [], dislikes: [], hearts: [], comments: [],
        imageEdits: { ...defaultImageEdits, frame: 'frame-censor-bar' },
        postColor: 'hsl(120, 30%, 20%)',
    }
];


// --- APP UI & ADS ---

export const forYouCardsData = [
    {
        id: 'find-friends',
        title: 'Find Friends',
        subtitle: 'Connect & Play',
        imageUrl: 'https://images.unsplash.com/photo-1529156069898-49953e39b3ac?q=80&w=2069&auto=format&fit=crop',
        icon: 'user-plus-duotone',
        action: 'navigate',
        page: Page.Search,
        pageTitle: 'Find Friends',
    },
    {
        id: 'ai-creator',
        title: 'AI Creator Studio',
        subtitle: 'Generate hints & more!',
        imageUrl: 'https://images.unsplash.com/photo-1677756119517-756a188d2d94?q=80&w=2070&auto=format&fit=crop',
        icon: 'brain-duotone',
        action: 'navigate',
        page: Page.AIHome,
        pageTitle: 'AI Creator Studio',
    },
    {
        id: '1',
        title: 'Daily Challenge',
        subtitle: 'New puzzles daily!',
        imageUrl: 'https://images.unsplash.com/photo-1563986768609-322da13575f3?q=80&w=2070&auto=format&fit=crop',
        icon: 'trophy-duotone',
        action: 'navigate',
        page: Page.DailyChallenge,
        pageTitle: 'Daily Challenge',
    },
    {
        id: '2',
        title: 'Recommended Groups',
        subtitle: 'Find your community.',
        imageUrl: 'https://images.unsplash.com/photo-1511632765486-a01980e01a18?q=80&w=2070&auto=format&fit=crop',
        icon: 'users-three-duotone',
        action: 'navigate',
        page: Page.RecommendedGroups,
        pageTitle: 'Recommended Groups',
    },
    {
        id: '3',
        title: 'Leaderboard',
        subtitle: 'See who is on top!',
        imageUrl: 'https://images.unsplash.com/photo-1578269174936-2709b6aeb913?q=80&w=2071&auto=format&fit=crop',
        icon: 'chart-bar-duotone',
        action: 'navigate',
        page: Page.Leaderboard,
        pageTitle: 'Leaderboard',
    },
];

export const presetThemes: PresetTheme[] = [
    { name: 'Default Purple', primary: 'hsl(259, 55%, 20%)', post: 'hsl(259, 55%, 20%)' },
    { name: 'Ocean Blue', primary: 'hsl(210, 50%, 25%)', post: 'hsl(190, 45%, 45%)' },
    { name: 'Sunset Orange', primary: 'hsl(25, 60%, 30%)', post: 'hsl(15, 70%, 50%)' },
    { name: 'Forest Green', primary: 'hsl(120, 30%, 20%)', post: 'hsl(120, 25%, 35%)' },
    { name: 'Royal Gold', primary: 'hsl(40, 50%, 20%)', post: 'hsl(45, 80%, 60%)' },
    { name: 'Ruby Red', primary: 'hsl(0, 50%, 30%)', post: 'hsl(0, 65%, 50%)' },
    { name: 'Slate Gray', primary: 'hsl(220, 10%, 25%)', post: 'hsl(220, 10%, 45%)' },
    { name: 'Black & Red', primary: '#000000', post: '#991B1B' }
];

export const mockRecommendedGroups: GroupGame[] = [
    {
        id: 'group-rec-1',
        name: 'Cinema Buffs',
        creatorId: 'user-x',
        members: ['user-1', 'user-2', 'user-3', 'user-4', 'user-5'],
        admins: ['user-x'],
        privacy: 'public',
        imageUrl: 'https://images.unsplash.com/photo-1489599849927-2ee91cede3ba?q=80&w=2070&auto=format&fit=crop',
        description: 'Guess the movie from a single scene!',
        puzzles: [],
        scores: {},
        solvedPuzzles: {},
        joinRequests: [],
    },
    {
        id: 'group-rec-2',
        name: 'World Travelers',
        creatorId: 'user-y',
        members: ['user-a', 'user-b', 'user-c'],
        admins: ['user-y'],
        privacy: 'ask-to-join',
        imageUrl: 'https://images.unsplash.com/photo-1507525428034-b723cf961d3e?q=80&w=2073&auto=format&fit=crop',
        description: 'Where in the world is this? Join us!',
        puzzles: [],
        scores: {},
        solvedPuzzles: {},
        joinRequests: [],
    },
    {
        id: 'group-rec-3',
        name: 'Nature Lovers',
        creatorId: 'user-z',
        members: ['user-d', 'user-e'],
        admins: ['user-z'],
        privacy: 'public',
        imageUrl: 'https://images.unsplash.com/photo-1441974231531-c6227db76b6e?q=80&w=2071&auto=format&fit=crop',
        description: 'Plants, animals, and landscapes.',
        puzzles: [],
        scores: {},
        solvedPuzzles: {},
        joinRequests: [],
    }
];

export const mockNotifications: Notification[] = [];

// FIX: Export mockAds array to be used in ad components
export const mockAds: MockAd[] = [
    {
        brandName: 'Cosmic Coffee',
        brandLogo: 'https://cdn-icons-png.flaticon.com/512/3081/3081648.png',
        slogan: 'The best coffee in the galaxy. Try our new Nebula Nectar!',
        callToAction: 'Order Now',
        imageUrl: 'https://images.unsplash.com/photo-1559496417-e7f25cb247f3?q=80&w=1887&auto=format&fit=crop',
        link: 'https://example.com',
    },
    {
        brandName: 'Starlight Hotels',
        brandLogo: 'https://cdn-icons-png.flaticon.com/512/2965/2965155.png',
        slogan: 'Your adventure starts here. Book your stay among the stars.',
        callToAction: 'Book Now',
        imageUrl: 'https://images.unsplash.com/photo-1571896349842-33c89424de2d?q=80&w=1780&auto=format&fit=crop',
        link: 'https://example.com',
    }
];
